module.exports = __webpack_public_path__ + "static/img/fcsv.5d9787b5.jpg";